import type { Resource } from '../../';
export const country_countries_RU: Resource = {"default":"Russia"};
